import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ReactComponent as Bell } from '../../assets/svg/BellSimple.svg';
import { ReactComponent as House } from '../../assets/svg/House.svg';
import { ReactComponent as Dashboard } from '../../assets/svg/Dashboard.svg';
import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined';
import { ReactComponent as BellFill } from '../../assets/svg/BellFill.svg';
import { NotificationIcon } from 'component/navigation/NotificationIcon';
import { useQuery } from '@apollo/client';
import { GET_NOTIFICATION } from '../../graph_ql/communication/notification/queries';
import { PATH } from 'routes/constant';
import { useAuth } from 'contexts/AuthContext';
import CreateStyleItemButton from 'component/navigation/create_style_item_button';
import themes from 'styles/themes';
const useStyles = makeStyles((theme) => ({
    navigation: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        left: 0,
        maxWidth: 1024,
        right: 0,
        background: themes.palette.primary.main,
        padding: '0 32px',
        margin: 'auto',
        height: '56px',
        minHeight: 56,
        borderTop: '1px solid rgb(204 204 204 / 20%)',
        '@media (max-width: 1024px)': {
            position: 'fixed',
        },
        zIndex: 98,
        // boxShadow: '0px -1px 0px rgba(74, 108, 114, 0.5)'
    },
}));
function NavigationBottomStylist(props) {
    const classes = useStyles();
    const { currentUser } = useAuth();
    const location = useLocation();
    const { loading, data: notificationData } = useQuery(GET_NOTIFICATION, {
        variables: {
            paging: {
                size: 10,
                page: 0,
            },
        },
        context: {
            clientName: 'notification',
        },
        skip: !currentUser,
        fetchPolicy: 'cache-only',
    });
    const handleClick = (e) => {
        if (props.isDisable) e.preventDefault();
    };
    return (
        <Box id="bottom-nav" className={classes.navigation} px={3}>
            <Box
                display={'flex'}
                height={56}
                alignItems={'center'}
                justifyContent={'space-between'}
                // style={{ borderTop: "1px solid rgb(204 204 204 / 50%)" }}
            >
                <div>
                    <NavLink to={PATH.HOME} onClick={handleClick}>
                        <House style={{ color: themes.palette.common.white }} />
                    </NavLink>
                </div>

                <div>
                    <NavLink to={PATH.NOTIFICATIONS} onClick={handleClick}>
                        {loading &&
                            (location.pathname === PATH.NOTIFICATIONS ? (
                                <BellFill style={{ color: themes.palette.common.white }} />
                            ) : (
                                <Bell style={{ color: themes.palette.common.white }} />
                            ))}
                        {!loading && <NotificationIcon data={notificationData} />}
                    </NavLink>
                </div>
                <div>
                    <CreateStyleItemButton {...props} />
                </div>
                <div>
                    <NavLink to={PATH.STYLIST_DASHBOARD} onClick={handleClick}>
                        <Dashboard style={{ color: themes.palette.common.white }} />
                    </NavLink>
                </div>
                <div>
                    <NavLink to={PATH.PROFILE} onClick={handleClick}>
                        <AccountCircleOutlined style={{ color: themes.palette.common.white }} />
                    </NavLink>
                </div>
            </Box>
        </Box>
    );
}

export default NavigationBottomStylist;
